import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";
import { FormatDate } from "../components/documentacion/FormatDate";

import { useState, useEffect } from "react";
import * as API from "../services/audit";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllAuditByTax(params.tratamientoId);
}

export function AuditList(props) {
  const [auditList, setAudit] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllAuditByTax(props.id).then(setAudit).catch(console.log);
  }, [props.id]);
  return (
    <>
      {auditList?.length ? (
        <ul className="audit cpt-list">
          {auditList
            .sort((a, b) => {
              // Parse the dates from the meta objects
              const dateA = new Date(a.meta.metaFecha);
              const dateB = new Date(b.meta.metaFecha);
              // Compare the dates (descending order)
              return dateB - dateA;
            })
            .map((audit) => (
              <li key={audit.id}>
                <NavLink to={`${props.id}/cuestionarios/audit/${audit.id}`}>
                  {`${FormatDate(audit.meta.metaFecha)}`}
                </NavLink>
              </li>
            ))}
        </ul>

          ) : (
            <></>
          )}
    </>
  );
}



export function AuditListContent() {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>Audit</h1>
      </div>
      <div id="actions">
        {<Link className="button is-link" to={`new`}>Nuevo</Link>}
      </div>
    </>
  );
}